export const isValidDate = (dateString: string): boolean => {
  const regEx = /^\s*(3[01]|[12][0-9]|0?[1-9])\.(1[012]|0?[1-9])\.((?:19|20)\d{2})\s*$/;
  if (!dateString.match(regEx)) return false; // Invalid format
  return true;
};

export const formatSimpleDate = (dateString?: string): string => {
  if (!dateString) {
    return '';
  }
  const dateStringLetters = dateString.replace(/\./g, '').replace(/-/g, '');
  if (dateStringLetters.length === 6) {
    return dateStringLetters.substring(0, 6).replace(/(\d{2})(\d{2})(\d{2})/, '$1.$2.20$3');
  }
  if (dateStringLetters.length >= 8) {
    return dateStringLetters.substring(0, 8).replace(/(\d{2})(\d{2})(\d{2,4})/, '$1.$2.$3');
  }
  return dateString;
};

export const dateToYYYYMMDDdate = (dateString: Date | string): string => {
  if (dateString instanceof Date && !Number.isNaN(dateString)) {
    const date = dateString.toISOString();
    return date.split('T')[0];
  }

  return dateString as string;
};

export const convertToYYYYMMDDdate = (dateString: string): string =>
  dateString.replace(/\./g, '-').split('-').reverse().join('-');

export const convertShortDate = (date: string): string => {
  if (date.length === 8) {
    return date.replace(/(\d\d)(\d\d)(\d\d\d\d)/, '$1.$2.$3');
  }
  if (date.length === 6) {
    return date.replace(/(\d\d)(\d\d)(\d\d)/, '$1.$2.20$3');
  }
  return date;
};

export const convertToDDMMYYYdate = (dateString?: string): string => {
  if (dateString) {
    return dateString.replace(/-/g, '.').split('.').reverse().join('.');
  }
  return '';
};

export const isYYYYMMDDdate = (dateString: unknown): boolean => {
  if (typeof dateString === 'string' || dateString instanceof String) {
    if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
      return true;
    }
    return false;
  }
  return false;
};

export const isValidDateCharacter = (character: string): boolean => /^[0-9-.]*$/.test(character);
export const currentDate = (): string => new Date().toLocaleString('sv-SE', { timeZone: 'Europe/Stockholm' });
export const todaysDateAndCurrentTime = (): string => `${todaysDate()} ${currentTime()}`;
export const createDate = (input?: string | number | Date | [number, number, number]): Date => {
  if (!input) return new Date();
  if (Array.isArray(input)) return new Date(input[0], input[1], input[2]);
  {
    return new Date(input);
  }
};

const todaysDate = (): string => {
  const today = new Date();
  let dd: string | number = today.getDate();
  let mm: string | number = today.getMonth() + 1;
  const yyyy = today.getFullYear();
  if (dd < 10) {
    dd = `0${dd}`;
  }
  if (mm < 10) {
    mm = `0${mm}`;
  }
  return `${dd}.${mm}.${yyyy}`;
};
const currentTime = (): string => new Date().toLocaleTimeString('nb-NO', { timeZone: 'Europe/Oslo' });
